
import { Modal, Button, Table } from '@scuf/common';
import React, { useState, useEffect } from 'react';
import { getActiveLoggedUsers } from 'src/services/Profiles';
import './ActiveuserList.scss';
import {getCurrentRole} from 'src/slices/onBoardingSlice';
import {useSelector} from 'react-redux';


interface ActiveUsers {
    first_name: string,
    user_id: string,
    last_name: string,
    email: string,
    last_login_timestamp: string
}

export const ActiveUserList = () => {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [users, setUsers] = useState<ActiveUsers[]>([]);
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const currentRole = useSelector(getCurrentRole);
    const [duration, setDuration] = useState<number>(5)

    useEffect(() => {
        getUsers();
    }, []);

    const getUsers = async () => {
        setLoading(true);
        const users: ActiveUsers[] = await getActiveLoggedUsers(currentRole, duration);
        if (users && users.length > 0) {
            setUsers(users);
            setError(null);
        } else {
            setError(`Unable to Fetch users. Please click 'Refresh Button' or  Try again later.`);
            setUsers([]);
        }
        setLoading(false);
    }

    return (
        <div className='user-list-container'>
            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                closeIcon
                className='user-list-modal'
            >
                <Modal.Header>
                    {`Active Logged Users (${users.length})`}
                    <div className="right">
                        <Button
                            content='Refresh'
                            data-testid='refresh-btn'
                            className='refresh-users-button'
                            onClick={() => { getUsers() }}
                            loading={loading}
                            disabled={loading}
                        ></Button>
                    </div>
                </Modal.Header>
                <Modal.Content>
                    {!error && <div className={`user-table-view-container ${loading && 'loading'}`}>
                        <Table>
                            <Table.Header>
                                <Table.HeaderCell content="Name" />
                                <Table.HeaderCell content="Email" />
                                <Table.HeaderCell content="User Id" />
                            </Table.Header>
                            <Table.Body>
                                {users.map((user) => {
                                    return (
                                        <Table.Row>
                                            <Table.Cell singleLine>{`${user.first_name} ${user.last_name}`}</Table.Cell>
                                            <Table.Cell>{`${user.email}`}</Table.Cell>
                                            <Table.Cell>{`${user.user_id}`}</Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                        </Table>

                    </div>}
                    {error && <span>{error}</span>}
                </Modal.Content>
            </Modal>
            <div className='circles'
                data-testid='modal-btn'
                onClick={() => {
                    setOpenModal(true);
                    getUsers();
                }
                }>
                {<span>{users.length || 0}</span>}
                <div className='user-list-glance'>{users.map((user) => user.first_name).join(', ')}</div>
            </div>
        </div>

    )
}

export default ActiveUserList;
